<template>
  <ion-card mode="ios" style="margin: 15px 0; background: #fff">
    <ion-card-header>
      <slide-y-up-transition :duration="700">
        <h6 v-show="show" class="text-up m-0">Aktywacje</h6>
      </slide-y-up-transition>
    </ion-card-header>
    <ion-card-content style="padding-top: 0">
      <slide-y-up-transition :duration="500" :delay="200">
        <p v-if="show && activationContracts.length === 0"
           class="text-center"
           style="margin-bottom: 10px">Brak udziału w aktywacji
        </p>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="500" :delay="200">
        <table v-if="show && activationContracts.length > 0" class="table table-loyalty-activations">
          <thead>
          <tr>
            <th>Nazwa</th>
            <th>Kwartał</th>
            <th>Data podpisania</th>
            <th class="text-right"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in activationContracts" :key="index">
            <td>
              <span>{{ item.name }}</span>
            </td>
            <td>{{ item.quarter }}</td>
            <td>{{ item.signedAt }}</td>
            <td>
              <ion-button mode="ios"
                          fill="outline"
                          size="small"
                          @click="downloadFile(item.uuid)">
                <svg class="icon icon-download-outline"><use xlink:href="#icon-download-outline"></use></svg>
              </ion-button>
            </td>
          </tr>
          </tbody>
        </table>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="500" :delay="400">
        <div v-if="show && canInvite">
          <ion-button mode="ios"
                      fill="outline"
                      size="small"
                      @click="goTo('LoyaltySignupActivation', sfa)"
                      class="btn mt-10">Zaproś do aktywacji
          </ion-button>
        </div>
      </slide-y-up-transition>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import goTo from '@/mixins/goto';
  import Save from '@/services/Save';

  export default {
    name: 'CardLoyaltyActivations',
    props: ['canInvite'],
    mixins: [goTo],
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        sfa: state => state.clients.single ? state.clients.single.sfa : null, // TODO get from route slug
        activationContracts: state => state.clients.single ? state.clients.single.loyalty_program.activationContracts : null
      })
    },
    data() {
      return {
        show: false
      }
    },
    mounted(){
      this.show = true;
    },
    methods: {
      downloadFile(uuid){
        this.$store.dispatch('loyalty/LOYALTY_ACTIVATION_FILE_REQUEST', uuid)
            .then(resp => {
              Save.file(resp, "umowa.pdf", {type: "application/pdf"})
            })
      },
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-content {
    padding: 8px 12px;
  }
</style>